import { createVNode as a, mergeProps as i } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PrintOutlinedStandard.js";
import d from "../components/PfIcon.js";
const t = (r, n) => {
  const e = {
    ...r,
    ...n.attrs
  };
  return a(d, i(e, {
    icon: o
  }), null);
};
t.displayName = "PrintOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
